module.exports = __webpack_public_path__ + "static/img/2.4b49805.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/2/1/eng/2.png
// module id = LSZj
// module chunks = 0